export enum ETestStatuses {
  ACTIVE  = 'active',
  DONE    = 'done',
  HIDDEN  = 'hidden',
  INIT    = 'init',
  VISIBLE = 'visible',
}
